module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/xeneta-adds-linescape/xeneta-adds-linescape.component.scss
// module id = 797
// module chunks = 0